<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card text-left">
					<div class="card-header bg-info text-white">
						Repartir todos los importes
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col text-center" v-for="ano in listaAnos" :key="ano">
								<div class="card">
									<div class="card-header bg-light">
										<b>{{ ano }}</b>
									</div>
									<div class="card-body">
										<div class="row">
											<div class="col-4" v-for="mes in listaMeses" :key="mes">
												<button class="btn btn-block btn-sm m-1" :disabled="ano < cerrado.ano || (ano === cerrado.ano && mes <= cerrado.mes)" :class="claseMes(ano, mes)" @click="toggleMes(ano, mes)">{{ meses[mes] }}</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="form-group mt-2">
							<label for="">Día de cobro</label>
							<select name="" id="" class="form-control" v-model="diaFactura">
								<option :value="null">Selecciona</option>
								<option v-for="(dia, index) in Array(31)" :key="index + 1" :value="index + 1">{{index + 1}}</option>
							</select>
						</div>
					</div>
					<div class="card-footer" v-if="mesesSeleccionados.length > 0 && diaFactura">
						<button class="btn btn-sm btn-primary" @click="repartir()">Distribuír todos</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import API from '../../services/api'

export default {
	name: 'repartir-todos',
	props: ['contrato', 'cliente'],
	data: function () {
		return {
			diaFactura: null,
			listaAnos: [],
			listaMeses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
			cerrado: {
				ano: null,
				mes: null
			},
			error: null,
			meses: ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			mesesSeleccionados: []
		}
	},

	created: function () {
		// Debemos obtener el mes de cierre
		API.getCierre()
			.then(res => {
				if (res.data.cierre.ano === 0) {
					// Tiene permisos para modificar facturación cerrada
					this.cerrado.ano = new Date().getFullYear() - 1
				} else {
					this.cerrado.ano = parseInt(res.data.cierre.ano)
					this.cerrado.mes = parseInt(res.data.cierre.mes)
				}
				this.listaAnos = [this.cerrado.ano, this.cerrado.ano + 1, this.cerrado.ano + 2]
			})
			.catch(e => {
				this.error = e.response.data.error || 'Error desconocido'
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				})
			})
	},

	methods: {

		claseMes (ano, mes) {
			mes = (mes < 10) ? '0' + mes : mes
			const id = ano.toString() + mes.toString()

			if (this.mesesSeleccionados.indexOf(id) >= 0) {
				return 'btn btn-sm btn-primary'
			} else {
				return 'btn btn-sm btn-default'
			}
		},

		toggleMes (ano, mes) {
			mes = (mes < 10) ? '0' + mes : mes
			const id = ano.toString() + mes.toString()
			const ind = this.mesesSeleccionados.indexOf(id)

			if (ind < 0) {
				this.mesesSeleccionados.push(id)
			} else {
				this.mesesSeleccionados.splice(ind, 1)
			}
		},

		cerrar () {
			this.$emit('cerrar')
		},

		checkLinea (pagos) {
			for (let i = 0; i < pagos.length; i++) {
				if (pagos[i].ano < this.cerrado.ano || (pagos[i].ano === this.cerrado.ano && pagos[i].mes <= this.cerrado.mes)) {
					return false
				}
			}

			return true
		},
		repartir () {
			let nuevo = JSON.parse(JSON.stringify(this.contrato))
			nuevo.fecha_inicio = this.contrato.fecha_inicio
			nuevo.fecha_fin = this.contrato.fecha_fin

			// TODO: Repartimos
			for (let i = 0; i < nuevo.lineas.length; i++) {
				if (!this.checkLinea(nuevo.lineas[i].pagos)) {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: `La línea de soporte ${nuevo.lineas[i].nombreSoporte} con el producto ${nuevo.lineas[i].nombreProducto} con importe ${nuevo.lienas[i].importe} ya contiene facturación en meses cerrados, por lo que no se va a recalcular`
					})
				} else {
					nuevo.lineas[i].pagos = []

					if (this.contrato.dto_global > 0) {
						nuevo.lineas[i].importe = nuevo.lineas[i].importe - (nuevo.lineas[i].importe * this.contrato.dto_global / 100)
					}

					let media = nuevo.lineas[i].importe / this.mesesSeleccionados.length

					media = this.roundNumber(media, 2)
					let dif = nuevo.lineas[i].importe - (media * this.mesesSeleccionados.length)

					for (let m = 0; m < this.mesesSeleccionados.length; m++) {
						// Calculamos los días que tiene el mes por si el usuario ha seleccionado un día erróneo
						const ano = parseInt(this.mesesSeleccionados[m].substr(0, 4))
						const mes = parseInt(this.mesesSeleccionados[m].substr(4, 2)) - 1
						const fechaMes = new Date(ano, mes, 1, 0, 0, 0, 0)
						// Sumamos un mes y restamos un día
						fechaMes.setMonth(fechaMes.getMonth() + 1)
						fechaMes.setDate(fechaMes.getDate() - 1)
						const diaMax = fechaMes.getDate()
						const diaFactura = (this.diaFactura > diaMax) ? diaMax : this.diaFactura + 0
						nuevo.lineas[i].pagos.push({
							ID_facturacion: null,
							importe: media,
							ano: parseInt(this.mesesSeleccionados[m].substr(0, 4)),
							mes: parseInt(this.mesesSeleccionados[m].substr(4, 2)),
							dia: diaFactura
						})
					}

					nuevo.lineas[i].pagos[nuevo.lineas[i].pagos.length - 1].importe = this.roundNumber(media + dif, 2)
				}
			}

			for (let i = 0; i < nuevo.lineasConceptos.length; i++) {
				nuevo.lineasConceptos[i].pagos = []

				let media = nuevo.lineasConceptos[i].importe / this.mesesSeleccionados.length

				media = this.roundNumber(media, 2)
				let dif = nuevo.lineas[i].importe - (media * this.mesesSeleccionados.length)

				for (let m = 0; m < this.mesesSeleccionados.length; m++) {
					const ano = parseInt(this.mesesSeleccionados[m].substr(0, 4))
					const mes = parseInt(this.mesesSeleccionados[m].substr(4, 2)) - 1
					const fechaMes = new Date(ano, mes, 1, 0, 0, 0, 0)
					// Sumamos un mes y restamos un día
					fechaMes.setMonth(fechaMes.getMonth() + 1)
					fechaMes.setDate(fechaMes.getDate() - 1)
					const diaMax = fechaMes.getDate()
					const diaFactura = (this.diaFactura > diaMax) ? diaMax : this.diaFactura + 0
					nuevo.lineasConceptos[i].pagos.push({
						ID_facturacion: null,
						importe: media,
						ano: parseInt(this.mesesSeleccionados[m].substr(0, 4)),
						mes: parseInt(this.mesesSeleccionados[m].substr(4, 2)),
						dia: diaFactura
					})
				}

				nuevo.lineasConceptos[i].pagos[nuevo.lineasConceptos[i].pagos.length - 1].importe = this.roundNumber(media + dif, 2)
			}
			this.$emit('update:contrato', nuevo)
			this.$emit('cerrar')
		},
		roundNumber (num, scale) {
			return _.round(num, scale)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/listado/repartirImportes.vue